import React from "react";
import { Helmet } from "react-helmet";
import homeSliderBg01 from "../../images/General/homeslider2.jpg";
import homeSliderBg02 from "../../images/General/homeslider3.jpg";

const MetaDecorator = ({
  metaTitle,
  metaDesc,
  canonicalLink,
  noIndex,
  schema,
}) => {
  const appMode = process.env.REACT_APP_APP_MODE;

  return (
    <Helmet>
      {/* <=========== Preload image start ===========> */}
      <link rel="preload" as="image" href={homeSliderBg01} fetchpriority="high" />
      <link rel="preload" as="image" href={homeSliderBg02} fetchpriority="high" />
      {/* <=========== Preload image end ===========> */}

      <link rel="canonical" href={canonicalLink}></link>
      {noIndex ? (
        <meta name="robots" content=" noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDesc} />

      {appMode === "production" &&
        schema &&
        (Array.isArray(schema) ? (
          schema.map((item, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(item)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        ))}
    </Helmet>
  );
};

export default MetaDecorator;

// <========================= New Code Start ============================>
// import React from "react";
// import { Helmet } from "react-helmet";
// import { useLocation } from "react-router-dom";
// import metaData from "../../data/metaData";

// const MetaDecorator = ({ noIndex }) => {
//   const location = useLocation();
//   const currentMeta = metaData[location.pathname] || metaData["/"];

//   return (
//     <Helmet>
//       <link rel="canonical" href={currentMeta.canonical} />
//       {noIndex ? (
//         <meta name="robots" content="noindex, follow" />
//       ) : (
//         <meta name="robots" content="index, follow" />
//       )}
//       <title>{currentMeta.title}</title>
//       <meta name="description" content={currentMeta.description} />
//     </Helmet>
//   );
// };

// export default MetaDecorator;
// <========================= New Code End ============================>
